<template>
  <v-window>
    <template v-if="$vuetify.breakpoint.smAndUp">
      <v-bottom-sheet inset
                      v-model="visible"
                      persistent>
        <slot></slot>
      </v-bottom-sheet>
    </template>
    <template v-else>
      <v-dialog v-model="visible"
                persistent
                fullscreen>
        <v-card height="100%">
          <slot></slot>
        </v-card>
      </v-dialog>
    </template>
  </v-window>
</template>

<script>
export default {
  name: 'WspModal',
  watch: {
    visible: function(value) {
      this.visible = true;
    }
  },
  data() {
    return {
      visible: true
    };
  }
};
</script>

